// extracted by css-extract-rspack-plugin
export default {"status":"RqKfAvMW6wDnJqmJ","separator":"FdaWlajsa6Ukt9sa","unpublishButton":"ZPY_VBC3x0EPbYDH","reportLink":"BVrPFDyR0I6ivuPi","dialog":"Hk1AfoFul88IMfOm"};